import { render, staticRenderFns } from "./Comunity.vue?vue&type=template&id=03bc0e94&"
import script from "./Comunity.vue?vue&type=script&lang=js&"
export * from "./Comunity.vue?vue&type=script&lang=js&"
import style0 from "./Comunity.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports